import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
	Button,
	Intent,
	Alert,
	Checkbox,
	Icon,
} from '@blueprintjs/core';

import AddEditChannel  from './AddEditChannel';
import { addChannel, deleteChannel } from '../../slices/CodeTablesSlice';

import { ResultHeader, ResultHeaderWithSort, Result, TextFilter } from './ResultComponents';

function Results(props) {
	const {
		table_items,
		table_items_sort_ids,
		table_items_sort_field,
		table_items_sort_direction,
		setTableItemsSort,
		openAddEditItemDialog,
		tableItemsFilters,
		handleFilterChange,
		deleteItem,
	} = props;
	
	const sort_props = {
		setTableItemsSort:       setTableItemsSort,
		tableItemsSortField:     table_items_sort_field,
		tableItemsSortDirection: table_items_sort_direction,
	};
	
	return <div className='results mt-4 mb-4'>
		<div className='results-table'>
			<ResultHeader columnIdx={1} title='' />
			<ResultHeader columnIdx={2} title='Urejanje' />
			<ResultHeaderWithSort
				columnIdx={3} {...sort_props} title='Oznaka' fieldName='internal_code' />
			<ResultHeaderWithSort
				columnIdx={4} {...sort_props} title='Naziv' fieldName='title' />
			<ResultHeaderWithSort
				columnIdx={5} {...sort_props} title='Aktiven' fieldName='visible' />
			<ResultHeaderWithSort
				columnIdx={6} {...sort_props} title='Vrstni red' fieldName='ord' />
		</div>
		
		<div className='results-table filters-row'>
			<Result columnIdx={1} />
			<Result columnIdx={2} />
			<Result columnIdx={3} child={
				<TextFilter
					value={tableItemsFilters.internal_code}
					onChange={ event => handleFilterChange('internal_code', event) } />
			} />
			<Result columnIdx={4} child={
				<TextFilter
					value={tableItemsFilters.title}
					onChange={ event => handleFilterChange('title', event) } />
			} />
			<Result columnIdx={5} child={
				<Checkbox
					checked={tableItemsFilters.visible === 1}
					indeterminate={tableItemsFilters.visible === 0}
					onChange={event => {
						let checked = 0;
						if (tableItemsFilters.visible === 1) {
							checked = -1;
						}
						else if (tableItemsFilters.visible === 0) {
							checked = 1;
						}
						
						handleFilterChange('visible', checked);
					}} />
			} />
			<Result columnIdx={6} />
		</div>
		
		{table_items_sort_ids.map((id, idx) => {
			const item = table_items[id];
			
			return <div className='results-table' key={'countries-result--result-' + id}>
				<Result columnIdx={1} child={
					item.serial_internal_code
				} />
				<Result columnIdx={2} child={
					<>
						<Button
							icon='edit'
							intent='primary'
							minimal={true}
							small={true}
							onClick={() => openAddEditItemDialog(item)} />
						<Button
							icon='trash'
							intent='danger'
							minimal={true}
							small={true}
							onClick={() => deleteItem(item)} />
					</>
				} />
				<Result columnIdx={3} child={
					item.internal_code
				} />
				<Result columnIdx={4} child={
					item.title
				} />
				<Result columnIdx={5} child={
					item.visible ?
						<Icon icon='tick' color='#394b59' />
						:
						<Icon icon='cross' color='#ff0000' />
				} />
				<Result columnIdx={6} cls='text-right' child={
					item.ord
				} />
			</div>;
		})}
	</div>;
}

class Channels extends Component {
	constructor(props) {
		super(props);
		
		this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
		this.setTableItemsSort         = this.setTableItemsSort        .bind(this);
		this.refreshTableItemsSort     = this.refreshTableItemsSort    .bind(this);
		this.filterTableItems          = this.filterTableItems         .bind(this);
		this.handleFilterChange        = this.handleFilterChange       .bind(this);
		this.openAddEditItemDialog     = this.openAddEditItemDialog    .bind(this);
		this.closeAddEditItemDialog    = this.closeAddEditItemDialog   .bind(this);
		this.deleteItem                = this.deleteItem               .bind(this);
		
		const {
			table_items,
			table_items_sort_ids,
			table_items_filtered_ids,
		} = this.updateTableItemsFromProps(props);
		
		this.state = {
			table_items,
			table_items_sort_ids,
			table_items_filtered_ids,
			table_items_sort_field: 'ord',
			table_items_sort_direction: 'ASC',
			table_items_filters: {
				internal_code: '',
				title:         '',
				visible:       0,
			},
			add_edit_item_dialog_open: false,
			add_edit_item_dialog_item: null,
			item_delete_requested: null,
		};
		
		this.state.table_items_sort_ids = this.refreshTableItemsSort(
			this.state.table_items_sort_field,
			this.state.table_items_sort_direction,
			this.state.table_items_filtered_ids,
			table_items,
			true
		);
	}
	
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.channels != this.state.table_items) {
			this.setState(
				this.updateTableItemsFromProps(this.props)
			);
		}
	}
	
	updateTableItemsFromProps(props) {
		const ids = Object.keys(props.channels);
		
		let sort_ids = [];
		
		if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) {
			for (let i=0; i<this.state.table_items_sort_ids.length; i++) {
				const id = this.state.table_items_sort_ids[i];
				if (ids.indexOf(id) != -1) {
					sort_ids.push(id);
				}
			}
		}
		
		for (let i=0; i<ids.length; i++) {
			const id = ids[i];
			if (sort_ids.indexOf(id) == -1) {
				sort_ids.push(id);
			}
		}
		
		const table_items_sort_ids = this.state === undefined ? sort_ids :
			this.refreshTableItemsSort(
				this.state.table_items_sort_field,
				this.state.table_items_sort_direction,
				ids,
				props.channels,
				true
			);
		
		return {
			table_items: props.channels,
			table_items_sort_ids,
			table_items_filtered_ids: ids,
		};
	}
	
	setTableItemsSort(field) {
		let direction = 'ASC';
		if (this.state.table_items_sort_field == field) {
			direction = (this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC');
		}
		
		this.setState({
			table_items_sort_field:     field,
			table_items_sort_direction: direction,
		});
		
		this.refreshTableItemsSort(field, direction);
	}
	
	refreshTableItemsSort(field, direction, table_items_filtered_ids, items, only_return) {
		table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
		items = items || this.state.table_items;
		only_return = only_return || false;
		
		const ids = table_items_filtered_ids;
		ids.sort((a_key, b_key) => {
			const a = items[a_key][field];
			const b = items[b_key][field];
			
			if (field == 'title') {
				return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
			}
			
			return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
		});
		
		if (only_return) {
			return ids;
		}
		
		this.setState({
			table_items_sort_ids: ids,
		});
	}
	
	filterTableItems(filters) {
		const filters_internal_code = filters.internal_code.toUpperCase();
		const filters_title         = filters.title.toUpperCase();
		const filters_visible       = filters.visible;
		
		const ids = Object.keys(this.state.table_items);
		const filtered_ids = ids.filter(id => {
			const item = this.state.table_items[id];
			
			if (filters_internal_code != '' && item.internal_code.toUpperCase().indexOf(filters_internal_code) == -1) {
				return false;
			}
			
			if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) {
				return false;
			}
			
			if (filters_visible !== 0 &&
				(
					(item.visible === true  && filters_visible === -1) ||
					(item.visible === false && filters_visible ===  1)
				)
			) {
				return false;
			}
			
			return true;
		});
		
		this.setState({
			table_items_filtered_ids: filtered_ids,
			table_items_filters:      filters,
		});
		
		this.refreshTableItemsSort(
			this.state.table_items_sort_field,
			this.state.table_items_sort_direction,
			filtered_ids
		);
	}
	
	handleFilterChange(field_name, event) {
		const new_filters = {
			internal_code: this.state.table_items_filters.internal_code,
			title:         this.state.table_items_filters.title,
			visible:       this.state.table_items_filters.visible,
		};
		
		let val = event;
		if (val instanceof Object) {
			val = event.target.value;
		}
		new_filters[field_name] = val;
		
		this.filterTableItems(new_filters);
	}
	
	openAddEditItemDialog(item) {
		this.setState({ add_edit_item_dialog_open: true, add_edit_item_dialog_item: item });
	}
	closeAddEditItemDialog(item) {
		this.setState({ add_edit_item_dialog_open: false });
		
		if (item !== undefined) {
			this.props.dispatch(addChannel({ item, token: this.props.token, save_to_api: true }));
		}
	}
	deleteItem(item) {
		this.setState({ item_delete_requested: item, token: this.props.token });
	}
	
	render() {
		if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
		
		return <>
			{this.state.item_delete_requested === null ? null :
				<Alert
					cancelButtonText='Prekliči'
					confirmButtonText='Briši'
					canEscapeKeyCancel={true}
					canOutsideClickCancel={true}
					icon='trash'
					intent={Intent.DANGER}
					isOpen={true}
					onConfirm={() => {
						this.props.dispatch(deleteChannel(this.state.item_delete_requested.id_channel));
						this.setState({ item_delete_requested: null });
					}}
					onCancel={() => {
						this.setState({ item_delete_requested: null });
					}}>
					Ali res želite izbrisati ta zapis?
				</Alert>
			}
			
			{!this.state.add_edit_item_dialog_open ? null :
				<AddEditChannel
					closeAddEditItemDialog={this.closeAddEditItemDialog}
					item={this.state.add_edit_item_dialog_item} />
			}
			
			<div className='flex flex-col flex-grow channels-list'>
				<div className='pl-4 pt-4'>
					<Button intent='primary' icon='plus' onClick={() => this.openAddEditItemDialog(null)}>
						Nov vnos
					</Button>
				</div>
				
				<div className='flex-1 pl-4 pr-4'>
					<div className='flex-grow overflow-y-auto' style={{ flexBasis: '0' }}>
						<Results
							table_items={this.state.table_items}
							table_items_sort_ids={this.state.table_items_sort_ids}
							table_items_sort_field={this.state.table_items_sort_field}
							table_items_sort_direction={this.state.table_items_sort_direction}
							setTableItemsSort={this.setTableItemsSort}
							openAddEditItemDialog={this.openAddEditItemDialog}
							tableItemsFilters={this.state.table_items_filters}
							handleFilterChange={this.handleFilterChange}
							deleteItem={this.deleteItem} />
					</div>
				</div>
			</div>
		</>;
	}
}
Channels.propTypes = {
};

function mapStateToProps(state) {
	return {
		channels: state.CodeTablesSlice.channels,
		token:    state.UserSlice.token,
		user:     state.UserSlice.user,
	};
}

export default connect(mapStateToProps)(Channels);
